"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ConnectedMeControl = void 0;

var _reactI18next = require("react-i18next");

var _reactRedux = require("react-redux");

var _models = require("../../Notifications/models");

var _createAction = require("../../redux/createAction");

var _getUserImageUrl = require("../getUserImageUrl");

var _models2 = require("../models");

var _MeControl = require("./MeControl");

/**
 * Maps the external (i.e. own) props and the state to the properties of the MeControl control.
 * @param state The current redux state to map to props
 * @param ownProps The external properties to map to props
 * @returns The mapped properties that along with the actions
 * becomes the props (IMeControlProps) for the MeControl control
 */
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$user$auth, _state$user$auth$prof, _state$user$auth2, _state$user$auth2$pro, _state$user$auth3;

  if (state.user.auth === undefined || state.user.auth.profile === undefined) {
    return {
      isMeOpen: false,
      givenName: '',
      familyName: '',
      userName: ''
    };
  }

  return {
    accountUrl: ownProps.accountUrl,
    isMeOpen: ownProps.isOpen || false,
    givenName: ((_state$user$auth = state.user.auth) === null || _state$user$auth === void 0 ? void 0 : (_state$user$auth$prof = _state$user$auth.profile) === null || _state$user$auth$prof === void 0 ? void 0 : _state$user$auth$prof.given_name) || '',
    familyName: ((_state$user$auth2 = state.user.auth) === null || _state$user$auth2 === void 0 ? void 0 : (_state$user$auth2$pro = _state$user$auth2.profile) === null || _state$user$auth2$pro === void 0 ? void 0 : _state$user$auth2$pro.family_name) || '',
    userName: (_state$user$auth3 = state.user.auth) === null || _state$user$auth3 === void 0 ? void 0 : _state$user$auth3.userName,
    userImageUrl: (0, _getUserImageUrl.getUserImageUrl)(state.user.userImage)
  };
};
/**
 * Maps the dispatch actions to the props for the MeControl control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (IMeControlProps) for the MeControl control
 */


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    hideMe: (0, _createAction.createAction)(_models.NotificationsActions.dialogCanceled, dispatch),
    logOut: (0, _createAction.createAction)(_models2.UserActions.logOut, dispatch)
  };
};
/**
 * A redux connected MeControl control.
 * @description Supports translation
 */


var ConnectedMeControl = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactI18next.translate)('App')(_MeControl.MeControl));
exports.ConnectedMeControl = ConnectedMeControl;